import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    TextField,
    IconButton,
    useTheme,
    useMediaQuery,
    CircularProgress,
    } from "@mui/material";
import useSendPasswordReset from "../../../hooks/useSendPasswordReset";
import { useAlert } from "../../../context/AlertContext";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ForgotPassword = ({ open, handleClose }) => {


    const [email, setEmail] = useState("");
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { sendPasswordReset, response, loading, error } = useSendPasswordReset()
    const { showAlert } = useAlert();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (loading) return;

        const value = email.trim();
        if (!EMAIL_REGEX.test(value)) {
            showAlert('Digite um e-mail válido', 'warning');
            return;
        }
        sendPasswordReset({ email: value })
    };

    useEffect(() => {
        if (response) {
            setEmail('')
            showAlert(response, 'success');
            handleClose();
        }
    }, [response]);

    useEffect(() => {
    if (error) {
        showAlert(error, "error");
    }
    }, [error]);

    return (
        <>
            <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth
            PaperProps={{
                    sx: {
                    borderRadius: "12px",
                    position: "relative",
                    paddingRight: "12px",
                    minWidth: isMobile ? "auto" : 500,
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: 18,
                        height: "100%",
                        backgroundColor: "#d6b827",
                        borderTopRightRadius: "12px",
                        borderBottomRightRadius: "12px",
                    },
                    },
                }}
            >
                <DialogTitle sx={{ textAlign: "center", color: "#D4AF37", fontWeight: "bold", textTransform: 'uppercase' }}>
                    Esqueci a Senha

                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: "#707070 !important",
                        }}
                    >
                        <CloseIcon sx={{color: "#707070 !important",}} />
                    </IconButton>
                </DialogTitle>
                {/* form: o Enter no campo também envia */}
                <form onSubmit={handleSubmit} noValidate>
                <DialogContent>
                    <Typography align="center" sx={{ mb: 2 }}>
                    Digite seu email que enviaremos um link para redefinir sua senha.
                    </Typography>
                    <TextField
                    fullWidth
                    placeholder="email@provedor.com.br"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    />
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                    type="submit"
                    variant="outlined"
                    disabled={loading}
                    sx={{
                        color: "#D4AF37",
                        borderColor: "#D4AF37",
                        "&:hover": { backgroundColor: "#D4AF37", color: "#fff" }
                    }}
                    >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Enviar'}
                    </Button>
                </DialogActions>
                </form>
            </Dialog>
        </>
    )
}
export default ForgotPassword;